import { Message, Select } from "@arco-design/web-react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import i18n, { Language, LanguageType } from "../../i18n.config";
import IconGlobe from "../../assets/icons/IconGlobe";
import { endpoints } from "../../api/endpoints";
import { RootState } from "../../store/store";
import { setUserLanguage } from "../../store/userSlice";
import { useCurrentLanguage } from "../../utils/hooks/useCurrentLanguage";

import "./LanguageSelect.css"

const { Option } = Select;

const languages = [
  { value: Language.English, label: "English" },
  { value: Language.Spanish, label: "Español" },
];

type LanguageSelectProps = {
  color: string;
  withUserUpdate?: boolean;
}

export const LanguageSelect = ({color, withUserUpdate = false}: LanguageSelectProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const language = useSelector((state: RootState) => state.user.language);
  const currentLanguageFromI18n = useCurrentLanguage();
  const currentLanguage = withUserUpdate ? language : currentLanguageFromI18n;


  const handleChangeLanguage = async (newLang: LanguageType) => {
    try {
      if (withUserUpdate) {
        await axios.post(endpoints.changeLanguage, { language: newLang });
        dispatch(setUserLanguage(newLang));
      }

      i18n.changeLanguage(newLang);
    } catch (error) {
      console.error("Error changing language:", error);
      if (withUserUpdate) {
        Message.error(t('notification_messages.change_language_error'));
      } 
    }
  };

  return (
    <Select
      className="language-select"
      value={currentLanguage}
      onChange={handleChangeLanguage}
      renderFormat={(option) => (
        <div className="language-select__label" style={{ color: color }}>
          <IconGlobe className="language-select__icon" />
          {option?.value}
        </div>
      )}
      bordered={false}
      triggerProps={{ autoAlignPopupWidth: false }}
      arrowIcon={null}
    >
      {languages.map(({ value, label }) => (
        <Option key={value} value={value}>
          {label} <span className="language-select__option-value">({value})</span>
        </Option>
      ))}
    </Select>
  );
}